(function () {
  function getConfig() {
    return window.GiftWrapConfig || {};
  }

  function set(id) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ updates: { [id]: 1 }, attributes: { 'gift-wrapping': 'yes' } })
    }).then(async function (response) {
      refreshCart(await response.json());
    });
  }

  function remove(id) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ updates: { [id]: 0 }, attributes: { 'gift-wrapping': '' } })
    }).then(async function (response) {
      refreshCart(await response.json());
    });
  }

  function refreshCart(cartContent) {
    if (getConfig().isCartPage) {
      location.href = '/cart';
    } else {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartContent } })
      );
    }
  }

  // Delegated listener on document — registered once per page load.
  // Survives mini-cart AJAX re-injection because it lives on document, not on
  // the injected HTML. Reading config at event time so it always has the
  // current variant ID even if the config was set after this file loaded.
  if (!window._giftWrapListenerAttached) {
    document.addEventListener('change', function (event) {
      if (!event.target || event.target.id !== 'gift-wrapping') return;
      var id = event.target.dataset.giftWrapId;
      if (!id) return;
      if (event.target.checked) {
        set(id);
      } else {
        remove(id);
      }
    });
    window._giftWrapListenerAttached = true;
  }

  // Auto-correct inconsistent cart state on the cart page (where the inline
  // <script> executes synchronously before this file runs).
  var config = getConfig();
  var checkbox = document.getElementById('gift-wrapping');
  var autoId = checkbox && checkbox.dataset.giftWrapId;
  if (config.autoAction && autoId) {
    if (config.autoAction === 'set') {
      set(autoId);
    } else if (config.autoAction === 'remove') {
      remove(autoId);
    }
  }
})();
